// Module
var code = "<dimension-groups></dimension-groups>\n";
// Exports
module.exports = code;